export default __webpack_public_path__ + "static/media/mint-incentive-track-mobile.43bd2741.png";